<template>
    <div class="black-friday-steps" :class="theme">
        <h4 class="black-friday-steps__title">
            Boost your weight loss with your guided Personal Program
        </h4>
        <div class="black-friday-steps__list">
            <div class="step">
                <svg class="step__icon" width="24" height="61" viewBox="0 0 24 61" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle class="icon__circle" cx="12" cy="12" r="12" />
                    <path class="icon__symbol" d="M7.14258 17.4004H12.8086C13.5938 17.4004 13.9805 17.0137 13.9805 16.1641V11.7871C13.9805 11.043 13.6758 10.6445 13.0664 10.5625V8.99805C13.0664 7.62109 13.9395 6.87695 14.9883 6.87695C16.0371 6.87695 16.916 7.62109 16.916 8.99805V10.2461C16.916 10.6562 17.1562 10.873 17.4727 10.873C17.7832 10.873 18.0234 10.668 18.0234 10.2461V9.10938C18.0234 6.88281 16.541 5.81055 14.9883 5.81055C13.4355 5.81055 11.9531 6.88281 11.9531 9.10938V10.5508L7.24219 10.5566C6.45703 10.5566 5.9707 10.9492 5.9707 11.7871V16.1641C5.9707 17.0137 6.35742 17.4004 7.14258 17.4004Z" fill="white"/>
                    <path class="icon__line" d="M12 32V60" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="6 6"/>
                </svg>

                <div class="step__text">
                    <h5>Today</h5>
                    <p>Activate and start your Personal Program</p>
                </div>
            </div>

            <div class="step">
                <svg class="step__icon outline" width="26" height="96" viewBox="0 0 26 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle class="icon__circle" cx="13" cy="13" r="12"/>
                    <path class="icon__symbol" d="M8.32422 16.6016H17.6816C18.2793 16.6016 18.6484 16.2734 18.6484 15.7871C18.6484 15.1719 18.0801 14.6387 17.5527 14.1289C17.1426 13.7305 17.0488 12.8926 16.9727 12.125C16.8906 9.96875 16.2637 8.45117 14.7402 7.90039C14.5 7.12695 13.8672 6.53516 13 6.53516C12.1328 6.53516 11.5 7.12695 11.2598 7.90039C9.73633 8.45117 9.10938 9.96875 9.02734 12.125C8.95703 12.8926 8.85742 13.7305 8.44727 14.1289C7.91992 14.6387 7.35742 15.1719 7.35742 15.7871C7.35742 16.2734 7.7207 16.6016 8.32422 16.6016ZM13 19.0098C14.0371 19.0098 14.7871 18.2715 14.8691 17.416H11.1367C11.2129 18.2715 11.9688 19.0098 13 19.0098Z" />
                    <path class="icon__line" d="M13 33V95" stroke="#E2E3EE" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="6 6"/>
                </svg>

                <div class="step__text">
                    <h5>Week 1 - 12</h5>
                    <p>Log your meals, physical activity, and water intake to get continuous personalized support every day to stay on track</p>
                </div>
            </div>

            <div class="step">
                <svg class="step__icon" width="24" height="137" viewBox="0 0 24 137" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle class="icon__circle" cx="12" cy="12" r="12" />
                    <path class="icon__symbol" d="M11.5557 7.98535C11.6514 7.98535 11.7061 7.92383 11.7266 7.83496C11.918 6.74121 11.9043 6.69336 13.0869 6.47461C13.1758 6.46094 13.2373 6.39941 13.2373 6.31055C13.2373 6.21484 13.1758 6.15332 13.0869 6.13965C11.9043 5.93457 11.918 5.88672 11.7266 4.7793C11.7061 4.69043 11.6514 4.62891 11.5557 4.62891C11.46 4.62891 11.4053 4.69043 11.3916 4.7793C11.1934 5.87988 11.2139 5.9209 10.0244 6.13965C9.93555 6.16016 9.87402 6.21484 9.87402 6.31055C9.87402 6.39941 9.93555 6.46094 10.0312 6.47461C11.207 6.68652 11.1934 6.73438 11.3916 7.83496C11.4053 7.92383 11.46 7.98535 11.5557 7.98535ZM8.24707 12.7637C8.38379 12.7637 8.48633 12.668 8.5 12.5312C8.73926 10.7197 8.79395 10.7129 10.6807 10.3574C10.8174 10.3369 10.9131 10.2412 10.9131 10.1045C10.9131 9.96094 10.8105 9.8584 10.6807 9.84473C8.80078 9.58496 8.73926 9.52344 8.5 7.67773C8.48633 7.53418 8.38379 7.43848 8.24707 7.43848C8.10352 7.43848 8.00098 7.53418 7.9873 7.68457C7.76172 9.49609 7.67969 9.49609 5.80664 9.84473C5.66992 9.86523 5.57422 9.96094 5.57422 10.1045C5.57422 10.248 5.66992 10.3369 5.83398 10.3574C7.68652 10.6514 7.76172 10.7061 7.9873 12.5176C8.00098 12.668 8.10352 12.7637 8.24707 12.7637ZM12.9707 20.3447C13.1826 20.3447 13.3398 20.1943 13.374 19.9756C13.8662 16.2705 14.3857 15.71 18.0361 15.3066C18.2617 15.2793 18.4189 15.1152 18.4189 14.8965C18.4189 14.6846 18.2617 14.5205 18.0361 14.4932C14.3926 14.0693 13.8867 13.5293 13.374 9.82422C13.3398 9.60547 13.1826 9.45508 12.9707 9.45508C12.7588 9.45508 12.6016 9.60547 12.5674 9.82422C12.0752 13.5293 11.5557 14.0898 7.91211 14.4932C7.67969 14.5205 7.52246 14.6846 7.52246 14.8965C7.52246 15.1084 7.67969 15.2793 7.90527 15.3066C11.542 15.792 12.041 16.2705 12.5674 19.9756C12.6016 20.1943 12.7656 20.3447 12.9707 20.3447Z" />
                    <path class="icon__line" d="M12 136V32" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="6 6"/>
                </svg>


                <div class="step__text">
                    <h5>Week 12 - Beyond</h5>
                    <p>Progress towards your goal weight and maintain your results with guidance from our experts</p>
                    <span>*Results vary depending on your starting point, goals and effort.</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BlackFridaySteps',
    props: ['theme']
}
</script>

<style lang="scss" scoped>
.black-friday-steps {
    &.light {
        --text-color: #323653;
        --subtext-color: #979AAA;
        --svg-pic-stroke: #7D8BF7;
        --svg-pic-text: #FFFFFF;
        --svg-pic-sub: #979AAA;
    }

    &.dark {
        --text-color: #FFFFFF;
        --subtext-color: #737587;
        --svg-pic-stroke: #98A4FF;
        --svg-pic-text: #1C1E2C;
        --svg-pic-sub: #737587;
    }

    h4 {
        font-weight: 700;
        font-size: 1.5rem;
        letter-spacing: 0.02rem;
        margin: 1.5rem 0;
        color: var(--text-color);
    }

    &__list {
        display: flex;
        flex-direction: column;

        .step {
            display: flex;
            flex-direction: row;
            margin-bottom: 0.5rem;

            &__icon {
                min-width: 26px;
                margin-right: 0.8rem;

                .icon {
                    &__circle {
                        fill: var(--svg-pic-stroke);
                    }

                    &__symbol {
                        fill: var(--svg-pic-text);
                    }

                    &__line {
                        stroke: var(--svg-pic-sub);
                    }
                }

                &.outline {
                    .icon {
                        &__circle {
                            fill: transparent;
                            stroke: var(--svg-pic-sub);
                        }

                        &__symbol {
                            fill: var(--svg-pic-sub);
                        }
                    }
                }
                
            }

            &__text {
                color: var(--text-color);

                h5 {
                    font-weight: 700;
                    font-size: 1.1rem;
                    margin: 0;
                    margin-bottom: 0.5rem;
                }

                p, span {
                    font-size: 0.9rem;
                    letter-spacing: 0.01rem;
                    margin: 0;
                    margin-bottom: 0.5rem;
                }

                span {
                    color: var(--subtext-color)
                }
            }
        }
    }
}
</style>
